<template>
  <div class="drawer-overlay" @click.self="onClose">
    <aside class="drawer">

      <!-- HEADER -->
      <header class="drawer-header">
        <div class="header-info">
          <div class="header-icon">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M4 20V6.8C4 6.36 4.36 6 4.8 6H12V20"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M12 10H19.2C19.64 10 20 10.36 20 10.8V20"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M2.5 20H21.5"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />

              <path
                d="M7 10H9M7 14H9"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <div>
            <span class="header-label">
              Администрирование
            </span>

            <h2>
              Создание компании
            </h2>

            <p>
              Добавьте данные, профиль и контакты компании.
            </p>
          </div>
        </div>

        <button
          type="button"
          class="close-btn"
          aria-label="Закрыть"
          @click="onClose"
        >
          <svg viewBox="0 0 20 20" fill="none">
            <path
              d="M6 6L14 14M14 6L6 14"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </header>

      <!-- SCROLLABLE BODY -->
      <div class="drawer-scroll">

        <!-- IMAGES -->
        <section class="form-section image-section">
          <div class="section-heading">
            <div>
              <span class="section-label">
                Оформление
              </span>

              <h3>
                Изображения компании
              </h3>
            </div>

            <span class="section-number">
              01
            </span>
          </div>

          <CompanyImageUploader
            :companyId="selectedCompanyId"
            @update:backgroundFile="onBackgroundUpload"
            @update:logoFile="onLogoUpload"
          />
        </section>

        <!-- BASIC INFO -->
        <section class="form-section">
          <div class="section-heading">
            <div>
              <span class="section-label">
                Основная информация
              </span>

              <h3>
                Профиль компании
              </h3>
            </div>

            <span class="section-number">
              02
            </span>
          </div>

          <div class="fields-grid">

            <div class="field-block full">
              <label for="company-name">
                Название компании
              </label>

              <div class="input-shell">
                <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 20V7L12 3L20 7V20"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linejoin="round"
                    />

                    <path
                      d="M9 20V15H15V20"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <input
                  id="company-name"
                  v-model="name"
                  type="text"
                  placeholder="Например: Advanza"
                />
              </div>
            </div>

            <div class="field-block full">
              <label for="company-specifics">
                Сфера деятельности
              </label>

              <div class="input-shell">
                <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 7H20M4 12H16M4 17H12"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>

                <input
                  id="company-specifics"
                  v-model="specifics"
                  type="text"
                  placeholder="Например: HR, рекрутинг, консалтинг"
                />
              </div>
            </div>

            <div class="field-block full">
              <div class="field-heading">
                <label for="company-about">
                  О компании
                </label>

                <span class="counter">
                  {{ about.length }}/1500
                </span>
              </div>

              <div class="textarea-shell">
                <textarea
                  id="company-about"
                  v-model="about"
                  maxlength="1500"
                  placeholder="Расскажите о компании, команде, услугах и направлениях работы..."
                />
              </div>
            </div>
          </div>
        </section>

        <!-- CONTACTS -->
        <section class="form-section">
          <div class="section-heading">
            <div>
              <span class="section-label">
                Контакты
              </span>

              <h3>
                Связь с компанией
              </h3>
            </div>

            <span class="section-number">
              03
            </span>
          </div>

          <div class="fields-grid two-columns">
            <div class="field-block">
              <label for="company-email">
                Email
              </label>

              <div class="input-shell">
                <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect
                      x="3.5"
                      y="5"
                      width="17"
                      height="14"
                      rx="2"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />

                    <path
                      d="M5 7L12 12.5L19 7"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <input
                  id="company-email"
                  v-model="email"
                  type="email"
                  placeholder="hello@company.com"
                />
              </div>
            </div>

            <div class="field-block">
              <label for="company-website">
                Сайт компании
              </label>

              <div class="input-shell">
                <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="8.5"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />

                    <path
                      d="M3.5 12H20.5M12 3.5C14.2 5.8 15.3 8.63 15.3 12C15.3 15.37 14.2 18.2 12 20.5C9.8 18.2 8.7 15.37 8.7 12C8.7 8.63 9.8 5.8 12 3.5Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>

                <input
                  id="company-website"
                  v-model="website"
                  type="text"
                  placeholder="https://company.com"
                />
              </div>
            </div>
          </div>
        </section>

        <!-- LOCATION -->
        <section class="form-section">
          <div class="section-heading">
            <div>
              <span class="section-label">
                География
              </span>

              <h3>
                Местоположение
              </h3>
            </div>

            <span class="section-number">
              04
            </span>
          </div>

          <div class="autocomplete-block">

            <div class="custom-component-shell">
              <CityAutocomplete v-model="selectedCity" />
            </div>
          </div>

          <div class="autocomplete-block">
            <label>
              Адрес
            </label>

            <div class="custom-component-shell">
              <AddressAutocomplete
                @update:addressData="onAddressData"
              />
            </div>
          </div>

          <div class="fields-grid two-columns coordinates">
            <div class="field-block">
              <label for="latitude">
                Latitude
              </label>

              <div class="input-shell">
                <input
                  id="latitude"
                  v-model.number="latitude"
                  type="number"
                  step="0.00001"
                  placeholder="55.7558"
                />
              </div>
            </div>

            <div class="field-block">
              <label for="longitude">
                Longitude
              </label>

              <div class="input-shell">
                <input
                  id="longitude"
                  v-model.number="longitude"
                  type="number"
                  step="0.00001"
                  placeholder="37.6173"
                />
              </div>
            </div>
          </div>
        </section>

        <!-- SOCIAL -->
        <section class="form-section">
          <div class="section-heading">
            <div>
              <span class="section-label">
                Социальные сети
              </span>

              <h3>
                Публичные ссылки
              </h3>
            </div>

            <span class="section-number">
              05
            </span>
          </div>

          <div class="social-grid">

            <div class="social-field">
              <div class="social-brand">
                f
              </div>

              <input
                v-model="facebookId"
                type="text"
                placeholder="Facebook ID"
              />
            </div>

            <div class="social-field">
              <div class="social-brand">
                IG
              </div>

              <input
                v-model="instagramId"
                type="text"
                placeholder="Instagram ID"
              />
            </div>

            <div class="social-field">
              <div class="social-brand">
                X
              </div>

              <input
                v-model="twitterId"
                type="text"
                placeholder="Twitter / X ID"
              />
            </div>

            <div class="social-field">
              <div class="social-brand">
                TG
              </div>

              <input
                v-model="telegramId"
                type="text"
                placeholder="Telegram username"
              />
            </div>

            <div class="social-field">
              <div class="social-brand">
                YT
              </div>

              <input
                v-model="youtubeId"
                type="text"
                placeholder="YouTube ID"
              />
            </div>
          </div>
        </section>

      </div>

      <!-- FOOTER -->
      <footer class="drawer-footer">
        <div class="footer-state">
          <span
            class="validation-dot"
            :class="{ valid: isValid }"
          ></span>

          <span>
            {{
              isValid
                ? "Все обязательные поля заполнены"
                : "Заполните обязательные поля"
            }}
          </span>
        </div>

        <button
          type="button"
          class="submit-btn"
          :disabled="!isValid || isSubmitting"
          @click="submitCompany"
        >
          <span
            v-if="isSubmitting"
            class="button-spinner"
          ></span>

          <svg
            v-else
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 12.5L10 17L19 7"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          {{
            isSubmitting
              ? "Создание..."
              : "Создать компанию"
          }}
        </button>
      </footer>

      <div
        v-if="isSubmitting"
        class="overlay-spinner"
      >
        <div class="loading-card">
          <div class="spinner"></div>

          <div>
            <strong>
              Создаём компанию
            </strong>

            <span>
              Загружаем данные и изображения
            </span>
          </div>
        </div>
      </div>

    </aside>
  </div>
</template>

<script setup>
import {
  computed,
  ref,
  watch
} from "vue";

import AdminService
  from "../api/AdminService";

import CityAutocomplete
  from "../components/CityAutocomplete.vue";

import AddressAutocomplete
  from "../components/AddressAutocomplete.vue";

import CompanyImageUploader
  from "../components/CompanyImageUploader.vue";

const selectedCompanyId =
  ref(crypto.randomUUID());

const uploadedBackgroundUrl =
  ref(null);

const uploadedLogoURL =
  ref(null);

const visible = defineModel({
  type: Boolean
});

const emit = defineEmits([
  "close",
  "success"
]);

const name = ref("");
const specifics = ref("");
const about = ref("");
const email = ref("");
const website = ref("");

const regionId = ref(null);
const selectedCity = ref(null);

const street = ref("");

const latitude = ref(0);
const longitude = ref(0);

const facebookId = ref("");
const instagramId = ref("");
const twitterId = ref("");
const telegramId = ref("");
const youtubeId = ref("");

const isSubmitting = ref(false);

function onBackgroundUpload(url) {
  uploadedBackgroundUrl.value = url;

  console.log(
    "✅ Получен URL фона:",
    url
  );
}

function onLogoUpload(url) {
  uploadedLogoURL.value = url;

  console.log(
    "✅ Получен URL логотипа:",
    url
  );
}

function onAddressData(data) {
  console.log(
    "🏠 onAddressData:",
    data
  );

  street.value =
    data?.street ||
    data?.address ||
    data?.full_address ||
    "";

  latitude.value =
    Number(
      data?.latitude || 0
    );

  longitude.value =
    Number(
      data?.longitude || 0
    );
}

const isValid = computed(() => {
  return (
    name.value.trim().length >= 2 &&
    specifics.value.trim().length >= 2 &&
    about.value.trim().length >= 10 &&
    email.value.trim().includes("@") &&
    website.value.trim().length >= 4 &&
    regionId.value !== null &&
    Boolean(
      uploadedLogoURL.value
    ) &&
    Boolean(
      uploadedBackgroundUrl.value
    )
  );
});

watch(
  selectedCity,
  (value) => {
    if (!value) {
      regionId.value = null;
      return;
    }

    regionId.value =
      Number(
        value.region_id ||
        value._id ||
        value.id ||
        0
      );

    console.log(
      "🌍 Установлен regionId:",
      regionId.value
    );
  }
);

function onClose() {
  if (isSubmitting.value) {
    return;
  }

  visible.value = false;

  emit("close");
}

async function submitCompany() {
  if (
    !isValid.value ||
    isSubmitting.value
  ) {
    return;
  }

  try {
    isSubmitting.value = true;

    const payload = {
      companyId:
        selectedCompanyId.value,

      name:
        name.value.trim(),

      specifics:
        specifics.value.trim(),

      aboutCompany:
        about.value.trim(),

      email:
        email.value.trim(),

      website:
        website.value.trim(),

      regionID:
        regionId.value,

      street:
        street.value.trim(),

      latitude:
        Number(latitude.value),

      longitude:
        Number(longitude.value),

      urlOfLogo:
        uploadedLogoURL.value,

      urlOfBackground:
        uploadedBackgroundUrl.value,

      socialData: {
        facebookEnabled:
          Boolean(
            facebookId.value.trim()
          ),

        facebookId:
          facebookId.value.trim(),

        instagramEnabled:
          Boolean(
            instagramId.value.trim()
          ),

        instagramId:
          instagramId.value.trim(),

        twitterEnabled:
          Boolean(
            twitterId.value.trim()
          ),

        twitterId:
          twitterId.value.trim(),

        youtubeEnabled:
          Boolean(
            youtubeId.value.trim()
          ),

        youtubeId:
          youtubeId.value.trim(),

        telegramEnabled:
          Boolean(
            telegramId.value.trim()
          ),

        telegramId:
          telegramId.value.trim()
      }
    };

    console.log(
      "📦 ПОЛНЫЙ PAYLOAD:",
      payload
    );

    const result =
      await AdminService
        .createAdminCompany(
          payload
        );

    console.log(
      "✅ Компания создана:",
      result
    );

    emit(
      "success",
      "Компания успешно создана!"
    );

    onClose();

  } catch (error) {
    console.error(
      "❌ Ошибка создания компании:",
      {
        status:
          error?.response?.status,

        data:
          error?.response?.data,

        message:
          error?.message
      }
    );

  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

/* =========================================================
   OVERLAY
========================================================= */

.drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;

  display: flex;
  justify-content: flex-start;

  padding: 12px;

  background:
    rgba(9, 12, 18, 0.58);

  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* =========================================================
   DRAWER
========================================================= */

.drawer {
  width:
    min(
      940px,
      calc(100vw - 24px)
    );

  height:
    calc(100dvh - 24px);

  position: relative;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  color: #252830;
  background: #ffffff;

  border:
    1px solid
    rgba(22, 32, 50, 0.08);

  border-radius: 24px;

  box-shadow:
    0 30px 90px
    rgba(0, 0, 0, 0.32);

  animation:
    drawer-in
    0.3s
    cubic-bezier(
      0.22,
      1,
      0.36,
      1
    );
}

/* =========================================================
   HEADER
========================================================= */

.drawer-header {
  min-height: 94px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  flex-shrink: 0;

  padding:
    18px
    24px;

  border-bottom:
    1px solid
    #eceef2;

  background:
    radial-gradient(
      circle at 8% 0%,
      rgba(
        49,
        132,
        244,
        0.1
      ),
      transparent 230px
    ),
    #ffffff;
}

.header-info {
  min-width: 0;

  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  width: 48px;
  height: 48px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #3195f6,
      #5367e7
    );

  border-radius: 15px;

  box-shadow:
    0 9px 22px
    rgba(
      45,
      116,
      224,
      0.23
    );
}

.header-icon svg {
  width: 24px;
  height: 24px;
}

.header-label,
.section-label {
  display: block;

  color: #949aa5;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 9px;

  letter-spacing:
    0.08em;

  text-transform:
    uppercase;
}

.header-info h2 {
  margin: 3px 0 0;

  color: #252830;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 18px;
}

.header-info p {
  margin: 4px 0 0;

  color: #838a96;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 11px;
}

.close-btn {
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  cursor: pointer;

  color: #737b87;
  background: #f2f4f7;

  border: none;
  border-radius: 50%;

  transition:
    background-color
    0.2s ease,
    color
    0.2s ease,
    transform
    0.2s ease;
}

.close-btn svg {
  width: 18px;
  height: 18px;
}

.close-btn:hover {
  color: #252830;

  background:
    #e7eaf0;

  transform:
    rotate(5deg);
}

/* =========================================================
   SCROLL
========================================================= */

.drawer-scroll {
  min-height: 0;

  flex: 1;

  overflow-y: auto;
  overflow-x: hidden;

  padding:
    24px
    26px
    32px;

  scrollbar-gutter:
    stable;
}

.drawer-scroll::-webkit-scrollbar {
  width: 8px;
}

.drawer-scroll::-webkit-scrollbar-track {
  background:
    transparent;
}

.drawer-scroll::-webkit-scrollbar-thumb {
  background:
    rgba(
      99,
      108,
      123,
      0.3
    );

  border:
    2px solid
    transparent;

  border-radius:
    999px;

  background-clip:
    padding-box;
}

/* =========================================================
   SECTIONS
========================================================= */

.form-section {
  padding:
    22px;

  margin-bottom:
    18px;

  background:
    #ffffff;

  border:
    1px solid
    #e8ebef;

  border-radius:
    20px;

  box-shadow:
    0 6px 20px
    rgba(
      15,
      23,
      42,
      0.035
    );
}

.section-heading {
  display: flex;
  justify-content:
    space-between;
  align-items:
    center;

  gap: 15px;

  margin-bottom:
    20px;
}

.section-heading h3 {
  margin:
    3px 0 0;

  color:
    #2b3038;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    15px;
}

.section-number {
  color:
    #4b84dc;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    11px;

  padding:
    7px 9px;

  background:
    rgba(
      61,
      130,
      237,
      0.08
    );

  border-radius:
    10px;
}

/* =========================================================
   FIELD GRID
========================================================= */

.fields-grid {
  display: grid;

  grid-template-columns:
    1fr;

  gap: 17px;
}

.fields-grid.two-columns {
  grid-template-columns:
    repeat(
      2,
      minmax(
        0,
        1fr
      )
    );
}

.field-block {
  min-width: 0;
}

.field-block.full {
  grid-column:
    1 / -1;
}

.field-block label,
.autocomplete-block label {
  display: block;

  margin-bottom: 7px;

  color:
    #474d57;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}

.field-heading {
  display: flex;
  align-items: center;
  justify-content:
    space-between;

  gap: 10px;
}

.counter {
  color:
    #a0a5ae;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}

/* =========================================================
   INPUTS
========================================================= */

.input-shell {
  width: 100%;
  height: 52px;

  display: flex;
  align-items: center;

  background:
    #f6f7f9;

  border:
    1px solid
    #e0e4e9;

  border-radius:
    14px;

  box-shadow:
    inset
    0
    1px
    2px
    rgba(
      20,
      30,
      50,
      0.035
    );

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    box-shadow
    0.2s ease;
}

.input-shell:focus-within {
  background:
    #ffffff;

  border-color:
    #5c8ff5;

  box-shadow:
    0
    0
    0
    3px
    rgba(
      92,
      143,
      245,
      0.13
    );
}

.input-icon {
  width: 46px;
  height: 100%;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #858d99;
}

.input-icon svg {
  width: 19px;
  height: 19px;
}

.input-shell input {
  min-width: 0;
  height: 100%;
  flex: 1;

  padding:
    0
    14px
    0
    0;

  color:
    #252830;

  background:
    transparent;

  border:
    none;

  outline:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    13px;
}

.input-shell:not(:has(.input-icon))
input {
  padding:
    0
    14px;
}

.input-shell input::placeholder,
.textarea-shell textarea::placeholder,
.social-field input::placeholder {
  color:
    #a7abb3;
}

/* =========================================================
   TEXTAREA
========================================================= */

.textarea-shell {
  width: 100%;

  background:
    #f6f7f9;

  border:
    1px solid
    #e0e4e9;

  border-radius:
    15px;

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    box-shadow
    0.2s ease;
}

.textarea-shell:focus-within {
  background:
    #ffffff;

  border-color:
    #5c8ff5;

  box-shadow:
    0
    0
    0
    3px
    rgba(
      92,
      143,
      245,
      0.13
    );
}

.textarea-shell textarea {
  width: 100%;
  min-height: 150px;

  display: block;

  resize: vertical;

  padding:
    15px;

  color:
    #252830;

  background:
    transparent;

  border:
    none;

  outline:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    13px;

  line-height:
    1.55;
}

/* =========================================================
   AUTOCOMPLETE
========================================================= */

.autocomplete-block {
  margin-bottom:
    17px;
}

.custom-component-shell {
  width: 100%;

  overflow: visible;
}

/* =========================================================
   SOCIAL
========================================================= */

.social-grid {
  display: grid;

  grid-template-columns:
    repeat(
      2,
      minmax(
        0,
        1fr
      )
    );

  gap: 12px;
}

.social-field {
  min-width: 0;
  height: 50px;

  display: flex;
  align-items: center;
  gap: 10px;

  padding:
    0
    12px;

  background:
    #f6f7f9;

  border:
    1px solid
    #e0e4e9;

  border-radius:
    14px;

  transition:
    border-color
    0.2s ease,
    box-shadow
    0.2s ease;
}

.social-field:focus-within {
  border-color:
    #5c8ff5;

  box-shadow:
    0
    0
    0
    3px
    rgba(
      92,
      143,
      245,
      0.11
    );
}

.social-brand {
  width: 28px;
  height: 28px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3695f5,
      #5968e9
    );

  border-radius:
    9px;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    9px;
}

.social-field input {
  min-width: 0;
  flex: 1;

  color:
    #252830;

  background:
    transparent;

  border:
    none;

  outline:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    12px;
}

/* =========================================================
   FOOTER
========================================================= */

.drawer-footer {
  min-height: 76px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content:
    space-between;

  gap: 18px;

  padding:
    13px
    24px
    calc(
      13px +
      env(
        safe-area-inset-bottom
      )
    );

  background:
    rgba(
      255,
      255,
      255,
      0.96
    );

  border-top:
    1px solid
    #eceef2;

  backdrop-filter:
    blur(14px);

  -webkit-backdrop-filter:
    blur(14px);
}

.footer-state {
  display: flex;
  align-items: center;
  gap: 8px;

  color:
    #8a919c;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    10px;
}

.validation-dot {
  width: 7px;
  height: 7px;

  background:
    #c8ccd2;

  border-radius:
    50%;
}

.validation-dot.valid {
  background:
    #31b36f;

  box-shadow:
    0
    0
    0
    4px
    rgba(
      49,
      179,
      111,
      0.1
    );
}

.submit-btn {
  min-width: 210px;
  min-height: 46px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding:
    0
    18px;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3295f7,
      #5267e6
    );

  border:
    none;

  border-radius:
    14px;

  box-shadow:
    0
    8px
    19px
    rgba(
      47,
      111,
      221,
      0.22
    );

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    11px;

  cursor:
    pointer;

  transition:
    transform
    0.2s ease,
    box-shadow
    0.2s ease,
    opacity
    0.2s ease;
}

.submit-btn svg {
  width: 17px;
  height: 17px;
}

.submit-btn:hover:not(:disabled) {
  transform:
    translateY(-1px);

  box-shadow:
    0
    11px
    24px
    rgba(
      47,
      111,
      221,
      0.29
    );
}

.submit-btn:disabled {
  cursor:
    not-allowed;

  opacity:
    0.46;

  box-shadow:
    none;
}

/* =========================================================
   LOADING
========================================================= */

.overlay-spinner {
  position:
    absolute;

  inset:
    0;

  z-index:
    100;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  background:
    rgba(
      255,
      255,
      255,
      0.72
    );

  backdrop-filter:
    blur(7px);
}

.loading-card {
  display:
    flex;

  align-items:
    center;

  gap:
    14px;

  padding:
    18px
    22px;

  background:
    #ffffff;

  border:
    1px solid
    #e8ebef;

  border-radius:
    18px;

  box-shadow:
    0
    18px
    50px
    rgba(
      15,
      23,
      42,
      0.14
    );
}

.loading-card strong,
.loading-card span {
  display:
    block;
}

.loading-card strong {
  color:
    #252830;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    12px;
}

.loading-card span {
  margin-top:
    3px;

  color:
    #8a919c;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}

.spinner,
.button-spinner {
  border:
    2px solid
    rgba(
      63,
      130,
      237,
      0.2
    );

  border-top-color:
    #3f82ed;

  border-radius:
    50%;

  animation:
    spin
    0.7s
    linear
    infinite;
}

.spinner {
  width:
    30px;

  height:
    30px;
}

.button-spinner {
  width:
    16px;

  height:
    16px;

  border-color:
    rgba(
      255,
      255,
      255,
      0.3
    );

  border-top-color:
    #ffffff;
}

/* =========================================================
   DARK
========================================================= */

html[data-theme="dark"]
.drawer {
  color:
    #f1f2f4;

  background:
    #1c1c1f;

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );
}

html[data-theme="dark"]
.drawer-header {
  background:
    radial-gradient(
      circle at 8% 0%,
      rgba(
        49,
        132,
        244,
        0.1
      ),
      transparent
      230px
    ),
    #1c1c1f;

  border-bottom-color:
    #2d2e33;
}

html[data-theme="dark"]
.header-info h2,
html[data-theme="dark"]
.section-heading h3,
html[data-theme="dark"]
.loading-card strong {
  color:
    #f3f3f5;
}

html[data-theme="dark"]
.header-info p,
html[data-theme="dark"]
.footer-state,
html[data-theme="dark"]
.loading-card span {
  color:
    #9399a3;
}

html[data-theme="dark"]
.close-btn {
  color:
    #a6abb3;

  background:
    #2b2c31;
}

html[data-theme="dark"]
.close-btn:hover {
  color:
    #ffffff;

  background:
    #36373d;
}

html[data-theme="dark"]
.form-section {
  background:
    #242529;

  border-color:
    #34363b;

  box-shadow:
    none;
}

html[data-theme="dark"]
.field-block label,
html[data-theme="dark"]
.autocomplete-block label {
  color:
    #d2d4d8;
}

html[data-theme="dark"]
.input-shell,
html[data-theme="dark"]
.textarea-shell,
html[data-theme="dark"]
.social-field {
  background:
    #2c2d32;

  border-color:
    #414349;
}

html[data-theme="dark"]
.input-shell:focus-within,
html[data-theme="dark"]
.textarea-shell:focus-within {
  background:
    #303136;

  border-color:
    #5c8ff5;
}

html[data-theme="dark"]
.input-shell input,
html[data-theme="dark"]
.textarea-shell textarea,
html[data-theme="dark"]
.social-field input {
  color:
    #ffffff;
}

html[data-theme="dark"]
.input-shell input::placeholder,
html[data-theme="dark"]
.textarea-shell textarea::placeholder,
html[data-theme="dark"]
.social-field input::placeholder {
  color:
    #777c85;
}

html[data-theme="dark"]
.input-icon {
  color:
    #858b96;
}

html[data-theme="dark"]
.drawer-footer {
  background:
    rgba(
      28,
      28,
      31,
      0.96
    );

  border-top-color:
    #2d2e33;
}

html[data-theme="dark"]
.overlay-spinner {
  background:
    rgba(
      15,
      15,
      17,
      0.76
    );
}

html[data-theme="dark"]
.loading-card {
  background:
    #27282d;

  border-color:
    #393b40;
}

/* =========================================================
   TABLET
========================================================= */

@media (max-width: 900px) {
  .drawer {
    width:
      min(
        760px,
        calc(
          100vw -
          24px
        )
      );
  }

  .fields-grid.two-columns,
  .social-grid {
    grid-template-columns:
      1fr;
  }
}

/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 640px) {
  .drawer-overlay {
    padding:
      0;

    align-items:
      flex-end;
  }

  .drawer {
    width:
      100%;

    height:
      96dvh;

    border-left:
      none;

    border-right:
      none;

    border-bottom:
      none;

    border-radius:
      24px
      24px
      0
      0;
  }

  .drawer-header {
    min-height:
      82px;

    padding:
      14px
      16px;
  }

  .header-icon {
    width:
      42px;

    height:
      42px;

    border-radius:
      13px;
  }

  .header-icon svg {
    width:
      21px;

    height:
      21px;
  }

  .header-info h2 {
    font-size:
      15px;
  }

  .header-info p {
    display:
      none;
  }

  .drawer-scroll {
    padding:
      16px
      14px
      24px;
  }

  .form-section {
    padding:
      17px;

    border-radius:
      17px;
  }

  .section-heading {
    margin-bottom:
      17px;
  }

  .drawer-footer {
    gap:
      10px;

    padding:
      11px
      14px
      calc(
        11px +
        env(
          safe-area-inset-bottom
        )
      );
  }

  .footer-state {
    display:
      none;
  }

  .submit-btn {
    width:
      100%;

    min-height:
      48px;
  }

  .textarea-shell textarea {
    min-height:
      135px;
  }
}

/* =========================================================
   ANIMATIONS
========================================================= */

@keyframes drawer-in {
  from {
    opacity:
      0;

    transform:
      translateX(
        -28px
      );
  }

  to {
    opacity:
      1;

    transform:
      translateX(
        0
      );
  }
}

@keyframes spin {
  to {
    transform:
      rotate(
        360deg
      );
  }
}

@media (
  prefers-reduced-motion:
  reduce
) {
  .drawer,
  .spinner,
  .button-spinner {
    animation:
      none;
  }
}
</style>